import { Controller } from '@hotwired/stimulus'

// Reusable hover/focus tooltip.
//
//   <span data-controller="tooltip" data-tooltip-content-value="Explanation here">...</span>
//
// The bubble is appended to <body> and positioned absolutely so it can't be
// clipped by overflow containers (e.g. the report tables' overflow-x-auto).
export default class extends Controller {
  static values = { content: String }

  connect() {
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.element.addEventListener('mouseenter', this.show)
    this.element.addEventListener('mouseleave', this.hide)
    this.element.addEventListener('focusin', this.show)
    this.element.addEventListener('focusout', this.hide)
  }

  disconnect() {
    this.hide()
    this.element.removeEventListener('mouseenter', this.show)
    this.element.removeEventListener('mouseleave', this.hide)
    this.element.removeEventListener('focusin', this.show)
    this.element.removeEventListener('focusout', this.hide)
  }

  show() {
    if (this.tooltip || !this.contentValue) return

    this.tooltip = document.createElement('div')
    this.tooltip.textContent = this.contentValue
    this.tooltip.setAttribute('role', 'tooltip')
    this.tooltip.className =
      'absolute z-50 max-w-xs rounded-md bg-gray-800 px-2.5 py-1.5 text-xs font-normal normal-case tracking-normal text-left text-white shadow-lg pointer-events-none'
    document.body.appendChild(this.tooltip)
    this.position()
  }

  hide() {
    if (!this.tooltip) return

    this.tooltip.remove()
    this.tooltip = null
  }

  position() {
    const target = this.element.getBoundingClientRect()
    const bubble = this.tooltip.getBoundingClientRect()

    let top = target.top + window.scrollY - bubble.height - 6
    if (top < window.scrollY) top = target.bottom + window.scrollY + 6

    let left = target.left + window.scrollX + (target.width - bubble.width) / 2
    const maxLeft = window.scrollX + document.documentElement.clientWidth - bubble.width - 8
    left = Math.min(Math.max(left, window.scrollX + 8), maxLeft)

    this.tooltip.style.top = `${top}px`
    this.tooltip.style.left = `${left}px`
  }
}
